import Reports from './containers/ReportsContainer';

export default Reports;
